import { ActionDefinition } from "@wl/types/lib/types/actions/definition";
import { ActionDefinitionHistory } from "@wl/types/lib/types/actions/history";

/**
 * Action state.
 *
 * @export
 * @interface ActionState
 */
export interface ActionState {
    /**
     * Active action definitions.
     *
     * @type {ActionDefinition[]}
     * @memberof ActionState
     */
    active: ActionDefinition[];

    /**
     * Action definition history entries.
     *
     * @type {ActionDefinitionHistory[]}
     * @memberof ActionState
     */
    history: ActionDefinitionHistory[];
}

/**
 * Initial action module state.
 *
 * @return {(() => ActionState)}
 */
const state = (): ActionState => ({
    active: [],
    history: [],
});

export default state;
